import { CASUALITY_GENERAL } from 'containers/Casuality-General/constantes';
import { CASUALITY } from 'containers/Casuality/constantes';
import { LF } from 'containers/LineasFinancieras/Constantes/general';
import { MarineInland } from 'containers/MarineInland/constantes/general';
import { SEGUKIDS } from 'containers/Segurykids/constants';
import { usePantallaPago } from 'contexts/FormPagoContext';
import useQueryParams from 'hooks/useQueryParams';
import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router';
import PRODUCTOS from 'utils/constants/PRODUCTOS';

const BottomButtons = ({ onSubmit, onSubmitFormError }) => {
  const { codProducto, idPoliza } = useQueryParams();

  const history = useHistory();

  const methods = useFormContext();

  const statePantalla = usePantallaPago();
  const { newRoutes } = statePantalla;

  const onClickAtras = useCallback(() => {
    if (codProducto === PRODUCTOS.LINEAS_FINANCIERAS) {
      return history.push(`${LF.urls.vigencia}?idPoliza=${idPoliza}`);
    }

    if (codProducto === PRODUCTOS.CASUALITY) {
      return history.push(`${CASUALITY.urls.contratante}?id=${idPoliza}`);
    }

    if (codProducto === PRODUCTOS.CASUALITY_GENERAL) {
      return history.push(`${CASUALITY_GENERAL.urls.vigencia}?id=${idPoliza}`);
    }
    if (codProducto === PRODUCTOS.SEGUKIDS) {
      return history.push(`${SEGUKIDS.urls.asegurado}?idPoliza=${idPoliza}`);
    }

    return history.push(newRoutes.suscripcion.goBack);
  }, []);

  const onClickPrincipal = useCallback(() => {
    history.push(`${MarineInland.urls.datosLead}`);
    window.location.reload();
  }, [history]);

  return (
    <div className="row justify-content-center">
      <div className="col-sm-11 col-lg-10">
        <div className="row justify-content-around">
          <div className="col-11 col-md-6 col-lg-4">
            <button
              className="btn btn-primary btn-block d-flex justify-content-center flex-row align-items-center"
              onClick={onClickAtras}
              disabled={statePantalla.loadingForm}
            >
              <i
                className="pi pi-arrow-left"
                style={{
                  fontSize: '1.2rem',
                  paddingRight: '5px',
                }}
              />
              ATRÁS
            </button>
          </div>


          {codProducto === PRODUCTOS.MARINE_INLAND && <>
            <div className="col-11 col-md-6 col-lg-4">
              <button
                onClick={onClickPrincipal}
                className="btn btn-primary btn-block d-flex justify-content-center flex-row align-items-center"
              >
                <i
                  className="pi pi-save"
                  style={{
                    fontSize: '1.2rem',
                    paddingRight: '5px',
                  }}
                />
                GUARDAR Y SALIR
              </button>
            </div>
          </>}




          {statePantalla.showFormCancelarTokens !== true && (
            <div className="col-11 col-md-6 col-lg-4">
              <button
                className="btn btn-primary btn-block d-flex justify-content-center flex-row align-items-center"
                onClick={methods.handleSubmit(onSubmit, onSubmitFormError)}
                disabled={statePantalla.loadingForm}
              >
                {statePantalla.loadingForm ? 'PROCESANDO...' : 'CONTINUAR'}
                <i
                  className="pi pi-arrow-right"
                  style={{
                    fontSize: '1.2rem',
                    paddingLeft: '5px',
                  }}
                />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BottomButtons;
